<template>
  <div class="main tabs_main">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">生产时间：</span>
        <el-date-picker
          v-model="timeData"
          type="monthrange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </div>
      <div class="header_item">
        <el-button
          v-if="showButton('search')"
          icon="el-icon-search"
          @click="searchData()">
          查询
        </el-button>
      </div>
    </div>
    <div class="main_content">
      <!-- <div id="first_chart" class="main_content_chart"></div> -->
      <div id="second_chart" class="main_content_chart"></div>
    </div>
  </div>
</template>

<script>
import { buttonPinia } from '../../../../pinia';
export default {
  name: 'DuctpieceIndex',
  data() {
    return {
      timeData: '',
    }
  },
  mounted() {
    const dateYear = new Date().getFullYear();
    this.timeData = [`${dateYear}-01-01`, `${dateYear}-12-01`];
    this.searchData()
  },
  methods: {
    // 
    searchData() {
      this.searchPipeComparePlan();
      this.searchPipeMonthPlan();
    },
    // 查询管片环比增长率
    async searchPipeMonthPlan() {
      const { data } = await this.$api.Analyse.searchPipeMonthPlan({
        startTime: this.timeData ? this.timeData[0] : '',
        endTime: this.timeData ? this.timeData[1] : '',
      });
      if(data.length === 0) {
        this.$message.warning('请选择生产时间');
        return false;
      }
      this.$nextTick(() => {
        this.createCharts('first_chart', data);
      })
    },
    // 查询管片理论实际对比
    async searchPipeComparePlan() {
      const { data } = await this.$api.Analyse.searchPipeComparePlan({
        startTime: this.timeData ? this.timeData[0] : '',
        endTime: this.timeData ? this.timeData[1] : '',
      });
      if(data.length === 0) {
        this.$message.warning('请选择生产时间');
        return false;
      }
      this.$nextTick(() => {
        this.createCharts('second_chart', data);
      })
    },
     // 创建echart图表
    createCharts(name, data) {
      const labelData = data.map(item => item.month);
      const firstData = data.map(item => (item.count/10).toFixed(0) ? (item.count/10).toFixed(0) : 0);
      const planDatas = data.map(item => item.planProduct ? item.planProduct : 0);
      // const secondData = name === 'first_chart' ? data.map(item => item.rate ? item.rate : 0) : data.map(item => item.rate ? item.planProduct : 0);
      const chartsImage = this.$echarts.init(document.getElementById(name));
      const option = {
        animationDuration: 1500,
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            var relVal = params[0].name;
            if(name === 'first_chart') {
              for (let i = 0; i < params.length; i++) {
                if (params[i].componentIndex === 0) {
                  relVal +=
                    "<br/>" +
                    params[i].marker +
                    "月生产量" +
                    " : " +
                    params[i].value;
                } else {
                  relVal +=
                    "<br/>" +
                    params[i].marker +
                    "环比增长率" +
                    " : " +
                    params[i].value +
                    "%";
                }
              }
            } else {
              for (let i = 0; i < params.length; i++) {
                if (params[i].componentIndex === 0) {
                  relVal +=
                    "<br/>" +
                    params[i].marker +
                    "实际生产量" +
                    " : " +
                    params[i].value;
                } else {
                  relVal +=
                    "<br/>" +
                    params[i].marker +
                    "计划需求量" +
                    " : " +
                    params[i].value;
                }
              }
            }
            return relVal;
          },
        },
        grid: {
          top: "15%",
          right: "3%",
          left: "5%",
          bottom: "11%",
        },
        xAxis: [
          {
            type: "category",
            data: labelData,
            axisLine: {
              lineStyle: {
                width: 2,
                color: "#B7E4F7",
              },
            },
            axisLabel: {
              color: "#B7E4F7",
            },
            axisTick: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            // max: 100,
            splitNumber: 10,
            axisLabel: {
              formatter: "{value}",
              textStyle: {
                color: "#CAD3E0",
              },
            },
            splitLine: {
              lineStyle: {
                width: 2,
                type: "dashed",
                color: "#28477C",
              },
            },
          },
          {
            type: "value",
            // max: 100,
            splitNumber: 10,
            axisLabel: {
              formatter: "{value}%",
              textStyle: {
                color: "#B7E4F7",
              },
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            type: "bar",
            data: firstData,
            yAxisIndex: 0,
            itemStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient( 0, 0, 0, 1,
                  [
                    {
                      offset: 0,
                      color: "rgba(15, 106, 134, 1)", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(28, 186, 233, 1)", // 100% 处的颜色
                    },
                  ],
                  false
                ),
              },
            },
          },
          //原来的
          // {
          //   type: "bar",
          //   data: secondData,
          //   yAxisIndex: 1,
          //   itemStyle: {
          //     normal: {
          //       color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1,
          //         [
          //           {
          //             offset: 0,
          //             color: "rgba(194, 92, 61, 1)", // 0% 处的颜色
          //           },
          //           {
          //             offset: 1,
          //             color: "rgba(250, 205, 145, 1)", // 100% 处的颜色
          //           },
          //         ],
          //         false
          //       ),
          //     },
          //   },
          // },
          //修改的
          {
            type: 'bar',
            color:'#77d241',
            itemStyle: {
                      normal: {
                          label: {
                              show: true,		
                              position: 'top',	
                              textStyle: {	   
                                  color: 'black',
                                  fontSize: 12
                              }
                          }
                      }
                  },

            data: planDatas
          },
        ],
      }
      chartsImage.clear();
      chartsImage.setOption(option);
    },
    // 判断按钮权限信息
    showButton(str) {
      const pinia = buttonPinia();
      return pinia.$state.buttonInfo.includes(str);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/layout-main.scss";

.main_content_chart {
  position: relative;
  height: 50%;

  &:first-child {
    &::before {
      position: absolute;
      padding-bottom: 10px;
      width: 100%;
      content: '| 月生产环比';
      color: #20E8F1;
      top: 0;
      border-bottom: 1px solid #18499D;
    }
  }

  &:last-child {
    &::before {
      position: absolute;
      padding-bottom: 10px;
      width: 100%;
      content: '| 实际生产数据与计划需求量对比(块)';
      color: #20E8F1;
      top: 0;
      border-bottom: 1px solid #18499D;
    }
  }
}
</style>
